/**
 * ============================================================================
 * HomePageSections
 * ============================================================================
 *
 * Purpose: Client wrapper that applies per-section error boundaries on homepage.
 * Responsibility: Isolate section failures; preserve layout for healthy sections.
 * Risk Level: Low — no logic change on successful renders.
 * ============================================================================
 */

"use client";

import { memo, type ReactNode } from "react";
import { SectionErrorBoundary } from "@/components/common/ErrorBoundary";

interface HomePageSectionProps {
  section: string;
  children: ReactNode;
}

function HomePageSectionBase({ section, children }: HomePageSectionProps) {
  return (
    <SectionErrorBoundary sectionName={`home:${section}`}>
      {children}
    </SectionErrorBoundary>
  );
}

export const HomePageSection = memo(HomePageSectionBase);
HomePageSection.displayName = "HomePageSection";
